import { axios } from '../../services/axios';

export default async function getSRTTrunkTypesForCompany(companyID) {
    const result = await axios.get(
        `/Services/SRT/Company/${companyID}/TrunkTypes/Available`,
    );
    return result;
}
